import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { closeMenu, Translation as T } from "@awe-web/shared/lib";
import { MenuLink } from "@awe-web/shared/lib";
import { getHeaderLinks } from "../l10n/store.js";
import { useStartScreenPath } from "../user/store.js";
import { screenGroups } from "../routing/constants.js";
import { useBelongsToGroup } from "../routing/util.js";

import "./app_navigation.scss";

const BOOK_RENT_OBJECT = "FSD0000137";

export function AppNavigationLinks({ className, itemClassName, linkClassName, activeLinkClassName, linkTextClassName }) {

  const startScreenPath = useStartScreenPath();
  const headerLinks = useSelector(state => getHeaderLinks(state));
  const isReservationScreen = useBelongsToGroup(screenGroups.RESERVATION);

  const dispatch = useDispatch();

  const combinedClassName = classnames("app-navigation-links", className);
  const combinedItemClassName = classnames("app-navigation-links__item", itemClassName);
  const combinedLinkClassName = classnames("app-navigation-links__link", linkClassName);
  const combinedActiveLinkClassName = classnames("app-navigation-links__link--active", activeLinkClassName);
  const combinedLinkTextClassName = classnames("app-navigation-links__link-text", linkTextClassName);

  const mainLinkClassName = useMemo(() => {
    const result = [combinedLinkClassName];
    if (isReservationScreen) {
      result.push(combinedActiveLinkClassName);
    }
    return result.join(' ');
  }, [combinedActiveLinkClassName, combinedLinkClassName, isReservationScreen]);

  const onClickHandler = useCallback(() => {
    dispatch(closeMenu());
  }, [dispatch]);

  return (
    <ul className={combinedClassName}>
      <li className={combinedItemClassName}>
        <NavLink
          onClick={onClickHandler}
          className={mainLinkClassName}
          to={startScreenPath}
        >
          <T className={combinedLinkTextClassName} code={BOOK_RENT_OBJECT} />
        </NavLink>
      </li>
      {headerLinks.toJS().map((link) => (
        <li className={combinedItemClassName} key={link.id}>
          <MenuLink
            className={combinedLinkClassName}
            activeClassName={combinedActiveLinkClassName}
            pageName={link.pageName}
            url={link.url}
          >
            <span className={combinedLinkTextClassName}>{link.text}</span>
          </MenuLink>
        </li>
      ))}
    </ul>
  );
}

AppNavigationLinks.propTypes = {
  className: PropTypes.string,
  itemClassName: PropTypes.string,
  linkClassName: PropTypes.string,
  activeLinkClassName: PropTypes.string,
  linkTextClassName: PropTypes.string
};

export function AppNavigation({ collapsed, className }) {
  const combinedClassName = classnames("app-navigation", className);
  const itemClassName = "app-navigation__item";
  const linkClassName = classnames("app-navigation__link", {
    "app-navigation__link--collapsed": collapsed
  });
  const activeLinkClassName = "app-navigation__link--active";
  const linkTextClassName = "app-navigation__link-text";

  return (
    <nav className={combinedClassName}>
      <AppNavigationLinks
        itemClassName={itemClassName}
        linkClassName={linkClassName}
        activeLinkClassName={activeLinkClassName}
        linkTextClassName={linkTextClassName}
      />
    </nav>
  );
}

AppNavigation.propTypes = {
  className: PropTypes.string,
  collapsed: PropTypes.bool
};
